export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT = "LOGOUT";
export const LOAD_COMPANIES = "LOAD_COMPANIES";
export const LOAD_COMPANY_DATA = "LOAD_COMPANY_DATA";
export const SET_SELECTED_COMPANY = "SET_SELECTED_COMPANY";
export const SET_PROFILE_PICTURE = "SET_PROFILE_PICTURE";
export const SET_PROFILE_NAME = "SET_PROFILE_NAME";
export const ADD_PAYMENT_METHOD = "ADD_PAYMENT_METHOD";
export const UPDATE_PAYMENT_METHOD = "UPDATE_PAYMENT_METHOD";
export const LOAD_PAYMENT_METHODS = "LOAD_PAYMENT_METHODS";
export const SET_FETCHING_REFRESH_TOKEN = "SET_FETCHING_REFRESH_TOKEN";
export const SET_AUTH_TOKENS = "SET_AUTH_TOKENS";
export const LOAD_PROFILE_TOGGLES = "LOAD_PROFILE_TOGGLES";
export const ADD_INTRODUCTION = "ADD_INTRODUCTION";
export const ADD_HELP = "ADD_HELP";
export const SET_SELECTED_COMPANY_ID = "SET_SELECTED_COMPANY_ID";
export const SET_HAS_MISSING_PAYMENT_DETAILS = "SET_HAS_MISSING_PAYMENT_DETAILS";
export const SET_CAN_PAY_EMPLOYEE = "SET_CAN_PAY_EMPLOYEE";
export const LOAD_BUSINESS_UNIT_MANAGER_SETTINGS = "LOAD_BUSINESS_UNIT_MANAGER_SETTINGS";
export const UPDATE_BUSINESS_UNIT_MANAGER_SETTINGS = "UPDATE_BUSINESS_UNIT_MANAGER_SETTINGS";
export const LOAD_TAX_AGENT_OF_COMPANY = "LOAD_TAX_AGENT_OF_COMPANY";
export const HIDE_EULA = "HIDE_EULA";
export const HIDE_WINTCARD_PROMOTION = "HIDE_WINTCARD_PROMOTION";
export const UPDATE_INVOICE_ACTIVATION_STATE = "UPDATE_INVOICE_ACTIVATION_STATE";
export const SET_SHOW_ALL_COMPANIES_TODO_OVERVIEW = "SET_SHOW_ALL_COMPANIES_TODO_OVERVIEW";
